import React, { useContext, useEffect, useState } from 'react';
import styles from './MfAuthorization.module.css';
import AuthenticationContext from 'config/context/authenticationContext';
import { useMfImport } from 'features/compositions/context/MfImportContext';
import ActionLoader from 'components/shared/status/ActionLoader';
import ModalInputField from 'components/shared/modal/ModalInputField';
import { ArrowRightIcon } from 'assets/icons';
import GuiContext from 'config/context/guiContext';
import PluginsContext from 'config/context/pluginsContext';
import { testPrivateKey } from 'utils/validations';
import useTheme from 'config/useTheme';

const MfAuthorization = () => {
  const { dark } = useTheme();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pk, setPk] = useState('');
  const { setStep, setPkey } = useMfImport();
  const { isPermissionValid } = useContext(AuthenticationContext);
  const { getActiveByAccountName } = useContext(PluginsContext);

  const [validField, setValidField] = useState({
    pk: true
  })

  const { 
    userData: { guiname }
  } = useContext(GuiContext);

  const isActivePlugin = getActiveByAccountName(guiname)?.active?.includes(7);

  useEffect(() => {
    const checkPermission = async () => {
      await new Promise(resolve => setTimeout(resolve, 1000));

      if (isActivePlugin) {
        const valid = isPermissionValid("active");

        if (valid) {
          setStep(4);
        }
      }

      setLoading(false);
    };

    checkPermission();
  }, []);

  const goToTransmission = () => {
    const isPkValid = testPrivateKey(pk);
    if (!isPkValid) {
      setError('Invalid private key!');
    }
    setValidField({
      pk: isPkValid
    });

    if (!isPkValid) { return; };

    setPkey(pk);
    setStep(4);
  }

  if (loading) {
    return <div className={styles.mf_authorization}> <ActionLoader text="Authorization checking..." /></div>
  }

  return (
    <div className={`${styles.mf_authorization} ${dark ? styles.dark : ''}`}>
      <div className={styles.mf_authorization_data}>
        <p>
          {!isActivePlugin ? (
            <span>HOT KEY plugin is not active.</span>
          ) : (
            <span>HOT KEY is active, but no valid key is set.</span>
          )}
          <br />
          Enter your private key with "active" permission to authorize blockchain data transfer. Make sure you are in a secure and trusted environment.
        </p>

        <div className={styles.mf_insert_pk}>
          <ModalInputField
            privateKey
            placeholder="Private key"
            value={pk}
            setValue={(val) => setPk(val)}
            valid={validField.pk}
          />
        </div>
        {error && <span className={styles.error_message}>{error}</span>}
        <button disabled={!pk} onClick={() => goToTransmission()} className={styles.submit_btn}>Go to data transmission <ArrowRightIcon /></button>
      </div>
    </div>
  );
};

export default MfAuthorization;
